"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClient = createClient;
var _routing = require("../../routing.cjs");
var _index = require("../../types/index.cjs");
function createClient(api) {
  /**
   * @deprecated Use `subscribeToNewsroom` from `Subscriptions` instead
   */
  async function subscribe(newsroomId, payload) {
    const url = generateUrl(newsroomId);
    return api.post(url, {
      payload
    });
  }
  async function list(newsroomId, {
    limit,
    offset,
    search,
    sortOrder
  } = {}) {
    const url = generateUrl(newsroomId);
    return api.get(url, {
      query: {
        limit,
        offset,
        search,
        sort: _index.SortOrder.stringify(sortOrder)
      }
    });
  }
  async function doExport(newsroomId) {
    const url = generateUrl(newsroomId, '/export');
    const response = await api.post(url);
    return {
      downloadUrl: response.download_url
    };
  }
  return {
    subscribe,
    list,
    export: doExport
  };
}
function generateUrl(newsroomId, suffix = '') {
  const url = _routing.routing.newsroomSubscriptionsUrl.replace(':newsroom_id', String(newsroomId));
  return url + suffix;
}